<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div class="main">
  <div class="header">
    <div class="title">
      <p>{{ clickedAviso.titulo }}</p>
      <small>Enviado por: {{ clickedAviso.nomeRemetente }}</small>
    </div>

    <button (click)="close()">
      <img alt="fechar" src="../../../../assets/svg/icons/close.svg" />
    </button>
  </div>

  <div class="content">
    <p>{{ clickedAviso.mensagem }}</p>
  </div>

  <div class="paginator-container" *ngIf="allAvisos.length > 0">
    <p>Mostrando {{ currentIndex + 1 }} de {{ total }} avisos disponíveis</p>

    <div class="simple-paginator">
      <button (click)="previous()" [disabled]="currentIndex === 0">
        <img src="../../../../assets/svg/icons/previous.svg" alt="Anterior" />
      </button>

      <span>{{ currentIndex + 1 }}-{{ total }}</span>

      <button (click)="next()" [disabled]="currentIndex === total - 1">
        <img src="../../../../assets/svg/icons/next.svg" alt="Próximo" />
      </button>
    </div>
  </div>
</div>
